// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"c403aa8a","498":"5a365e5c","644":"f1eae40a","991":"27e49a94"}[chunkId] + ".chunk.js";
};